import request from '@/utils/request'

// 运营日报统计
export function getOperationReportSummary(data) {
  return request({
    url: '/crmOperationReport/summary',
    method: 'post',
    data: data || {}
  })
}
